import { RootActionTypes } from '../../../stores/types';
import ActionTypes from '../constants/action-types';

export default function updateFileStatus(files: FileList): RootActionTypes {
  return {
    type: ActionTypes.UPDATE_IMPORT_FILES_STATUS,
    payload: { files },
  };
}
